import { BookingItem, BookingItemProps } from './BookingItem';

interface BookingListProps {
  bookings: BookingItemProps[];
  onLoadMore?: () => void;
}

export function BookingList({ bookings, onLoadMore }: BookingListProps) {
  return (
    <div className="w-full">
      <div className="space-y-4">
        {bookings.map((booking) => (
          <BookingItem key={booking.id} {...booking} />
        ))}
      </div>

      {onLoadMore && (
        <div className="mt-5 mb-2 flex justify-start">
          <button
            onClick={onLoadMore}
            className="flex items-center gap-2 px-6 py-4 bg-[#8e2a2f] text-white rounded-lg font-['DM_Sans',sans-serif] font-bold text-sm hover:bg-[#7a2428] transition-all"
          >
            <span className="material-icons text-[18px]">sync</span>
            Load more
          </button>
        </div>
      )}
    </div>
  );
}
